export const faleConoscoTitles = {
  inicio: {
    title: "Olá! Como podemos ajudar?",
    subtitle: "Selecione a melhor opção para lhe atendermos",
  },
  "duvidas-frequentes": {
    title: "Dúvidas frequentes",
    subtitle: "Selecione o que faz mais sentido para você!",
  },
} as const;
